import { createSlice } from "@reduxjs/toolkit";

import { EMPTY_ARRAY } from "@/react/empty";

import initialTreeData from "./treeData";

export const name = "vccssAgents";
const initialState = {
  tree: initialTreeData,
};
const vccssAgentsSlice = createSlice({
  name,
  initialState,
  reducers: {
    setTreeState: (state, action) => {
      state.tree = action.payload;
    },
  },
});
export const { setTreeState } = vccssAgentsSlice.actions;
export const selectTreeState = (state) => state[name]?.tree ?? EMPTY_ARRAY;

export default vccssAgentsSlice.reducer;
